// extracted by mini-css-extract-plugin
export var container = "_r4-0";
export var dotAnimation = "_r4-2";
export var dotsLoading = "_r4-1";